<template>
  <b-modal id="update-multi-status">
    <div class="transfer">
      <form v-if="tripsIds.length" @submit.prevent="handleForm">
        <validation-observer ref="observer">
          <div class="transfer__header d-flex justify-content-between align-items-center">
            <h3>{{ $t('change-trips-status') }}</h3>
            <span>
              <img
                :src="require('@/assets/images/icons/popup-close.svg')"
                alt="popup close"
                @click="closePopup"
              />
            </span>
          </div>
          <div class="transfer__body">
            <b-alert :show="error && error.length ? true : false" variant="danger">
              <div v-if="Array.isArray(error)">
                <div
                  class="d-flex flex-column my-1"
                  v-for="(error_text, index) in error"
                  :key="index"
                >
                  {{ error_text }}
                </div>
              </div>
              <div v-else>
                <div v-html="error || '&nbsp;'"></div>
              </div>
            </b-alert>

            <div v-if="tripsIds.length" class="my-2">
              <h4>
                {{ $t('change-status-msg', { number: tripsIds ? tripsIds.length : 0 }) }}
              </h4>

              <div class="mt-3">
                <validation-provider name="status" rules="required" v-slot="{ errors }">
                  <b-form-radio-group
                    v-model="selected"
                    :options="options"
                    :checked="selected"
                    name="status"
                    class="d-flex"
                  ></b-form-radio-group>
                  <div class="error-text" v-if="errors && errors.length">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="transfer__footer d-flex justify-content-end">
            <div class="col-4">
              <base-button
                v-if="tripsIds.length"
                :class="[
                  'primary mt-3 mx-3',
                  {
                    'not-allowed':
                      this.$store.getters['enums/is_not_permitted']('changeJourneyStatus'),
                  },
                ]"
                variant="primary"
                type="submit"
              >
                {{ $t('change-status') }}
              </base-button>
              <base-button
                v-if="!tripsIds.length"
                class="primary mt-3 mx-3"
                variant="primary"
                @click="closePopup"
              >
                {{ $t('close') }}
              </base-button>
            </div>
          </div>
        </validation-observer>
      </form>
      <section v-else class="text-center transfer__empty mt-5 mb-0">
        <img src="@/assets/images/icons/popup-cancel-icon.svg" alt="" srcset="" />
        <h3 class="my-5">{{ $t('please-select-an-Item-at-least') }}</h3>
        <div class="transfer__footer d-flex justify-content-end">
          <div class="col-4">
            <base-button class="primary mt-3 mx-3" variant="primary" @click="closePopup">
              {{ $t('back') }}
            </base-button>
          </div>
        </div>
      </section>
    </div>
  </b-modal>
</template>

<script>
import TripService from '@/services/trip.service'

export default {
  name: 'SuccessModal',
  emits: ['refreshData'],
  props: ['tripsIds'],
  data() {
    return {
      error: null,
      branch: null,
      options: [
        { text: this.$t('start'), value: 'started' },
        { text: this.$t('cancel'), value: 'cancelled' },
      ],
      selected: null,
    }
  },

  methods: {
    closePopup() {
      this.$bvModal.hide('update-multi-status')
      this.$emit('refreshData')
      this.error = null
    },
    async handleForm() {
      const valid = await this.$refs.observer.validate()

      if (!valid) return
      else if (this.changeStatus());
    },
    changeStatus() {
      if (!this.$store.getters['enums/is_not_permitted']('changeJourneyStatus')) {
        this.loading = true
        this.error = null

        const data = {
          tripsIds: this.tripsIds,
          status: this.selected,
        }
        TripService.put(data, 'status')
          .then(() => {
            this.$emit('refreshData')
            this.$bvModal.hide('update-multi-status')
          })
          .catch(({ message }) => {
            this.error = message
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
  },
  i18n: {
    messages: {
      en: require('@/services/i18n/locales/en/operations.json'),
      ar: require('@/services/i18n/locales/ar/operations.json'),
    },
  },
}
</script>

<style lang="scss" scoped>
.transfer {
  padding-block: 32px 23px;

  &__header {
    margin-inline: 26px;
    border-block-end: 1px solid var(--color-14);
    padding-block-end: 26px;
    img {
      cursor: pointer;
    }
    h3 {
      font-weight: 700;
      font-size: 22px;
      line-height: 20px;
      letter-spacing: 0.25px;
      color: var(--color-17);
    }
  }
  &__body {
    margin-block-start: 17px;
    margin-inline: 26px;
    margin-block-end: 200px;
    h3 {
      font-weight: 700;
      font-size: 20px;
      line-height: 32px;
    }
    h4 {
      font-weight: 400;
      font-size: 16px;
      line-height: 29px;
    }
  }
  &__footer {
    border-top: 1px solid var(--color-23);
  }
}
</style>
